function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _excluded = ["alignRight", "applyText", "changeLabelOnSelect", "className", "defaultText", "description", "disabled", "dropUp", "dynamicDropAlign", "dynamicDropDirection", "error", "id", "iconNameClose", "iconNameOpen", "label", "labelWidth", "loader", "onChange", "options", "panelHeight", "panelWidth", "placeholder", "required", "resetText", "searchable", "selectAllLabel", "selected", "selectedDisplayTextAfter", "selectedDisplayTextBefore", "selectedIndex", "showFullSelected", "size", "removeMarginTop", "hideFooterButtons", "hideSelectAll"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import DropdownPanel from '../Dropdown/DropdownPanel';
import DropdownField from '../Dropdown/DropdownField';
import Checkbox from '../Checkbox';
import Loader from '../Loader';
import Button from '../Button';
import ClickListener from '../utils/ClickListener';
import ArrowKeyListener from '../utils/ArrowKeyListener';
var TAB_KEY = 9;
var UP_ARROW_KEY = 38;
var DOWN_ARROW_KEY = 40;

var DropdownMultiselect = /*#__PURE__*/function (_Component) {
  _inherits(DropdownMultiselect, _Component);

  var _super = _createSuper(DropdownMultiselect);

  function DropdownMultiselect(props) {
    var _this;

    _classCallCheck(this, DropdownMultiselect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onUpArrow", function (e) {
      var _this$state = _this.state,
          focusedItemIndex = _this$state.focusedItemIndex,
          open = _this$state.open;

      if (open) {
        e.preventDefault();
        var calcFocusedItemIndex = (focusedItemIndex || 0) > 0 ? focusedItemIndex - 1 : focusedItemIndex;

        _this.setState({
          focusedItemIndex: calcFocusedItemIndex
        });

        _this.iterateDropdownFocus(calcFocusedItemIndex);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDownArrow", function (e) {
      var _this$state2 = _this.state,
          focusedItemIndex = _this$state2.focusedItemIndex,
          open = _this$state2.open;

      if (open) {
        e.preventDefault();
        var count = _this.focusableItems.length;
        var calcFocusedItemIndex = (focusedItemIndex || 0) < count - 1 ? focusedItemIndex + 1 : focusedItemIndex;

        _this.setState({
          focusedItemIndex: calcFocusedItemIndex
        });

        _this.iterateDropdownFocus(calcFocusedItemIndex);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchType", function (e) {
      var searchable = _this.props.searchable;
      _this.filteredCheckboxes = {};
      _this.filteredCheckedCheckboxes = {};

      if (searchable) {
        _this.setState({
          selectedItemText: e.target.value,
          searchedText: {
            value: e.target.value,
            show: true
          }
        });

        _this.focusableItems = _this.dropdown.querySelectorAll('[role="option"],[role="menuitem"]');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setCheckedValues", function () {
      var _this$props = _this.props,
          selected = _this$props.selected,
          options = _this$props.options;
      var globalChecked = {};

      if (selected) {
        options.forEach(function (option, index) {
          if (selected.includes(option)) {
            Object.assign(globalChecked, _defineProperty({}, index, option));
          } // backward compatible just in case - to be deprecated


          if (selected.includes(index)) {
            Object.assign(globalChecked, _defineProperty({}, index, option));
          }
        });
      }

      return globalChecked;
    });

    _defineProperty(_assertThisInitialized(_this), "setDisplayText", function () {
      var displayText = _this.displayTextGenerator();

      _this.setState({
        selectedItemText: displayText
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchArrowKeyPress", function (e) {
      var focusedItemIndex = _this.state.focusedItemIndex;

      if (e.which === UP_ARROW_KEY || e.which === DOWN_ARROW_KEY) {
        e.preventDefault();

        if (_this.focusableItems[focusedItemIndex]) {
          _this.iterateDropdownFocus();
        } else {
          _this.iterateDropdownFocus(0);
        }
      }

      e.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_this), "iterateDropdownFocus", function (focusIndex) {
      var focusedItemIndex = _this.state.focusedItemIndex;

      if (focusIndex || focusIndex === 0) {
        _this.setState({
          focusedItemIndex: focusIndex
        });

        if (_this.focusableItems[focusIndex]) {
          _this.focusableItems[focusIndex].focus();
        }
      } else {
        var count = _this.focusableItems.length;

        if (focusedItemIndex >= 0 && focusedItemIndex < count) {
          if (_this.focusableItems[focusedItemIndex]) {
            _this.focusableItems[focusedItemIndex].focus();
          }
        } else {
          _this.focusableItems[0].focus();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      var focusedItemIndex = _this.state.focusedItemIndex;

      var displayText = _this.displayTextGenerator();

      _this.setState({
        open: false,
        selectedItemText: displayText,
        searchedText: {
          value: '',
          show: false
        }
      });

      if (focusedItemIndex !== -1) {
        _this.setState(function (prevState) {
          return {
            focusedItemIndex: prevState.selectedItemIndex
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      if (e.key === 'Enter') _this.toggleDropdown(e);
      if (e.which === DOWN_ARROW_KEY) _this.open();
    });

    _defineProperty(_assertThisInitialized(_this), "open", function () {
      _this.setState({
        open: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDropdown", function (e) {
      var disabled = _this.props.disabled;
      var open = _this.state.open;

      if (!disabled) {
        if (!open) {
          _this.open();
        } else {
          _this.close();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelects", function (info, e) {
      var onChange = _this.props.onChange;
      var index = info.index,
          value = info.value;

      if (e.target.checked) {
        _this.selectedArray.push(value);

        _this.selectedValueArray.push(value);

        Object.assign(_this.globalCheckedCheckboxes, _defineProperty({}, index, value));
      } else {
        _this.selectedArray = _this.selectedArray.filter(function (item) {
          return item !== value;
        });
        _this.selectedValueArray = _this.selectedValueArray.filter(function (item) {
          return item !== value;
        });
        delete _this.globalCheckedCheckboxes[index];
        delete _this.filteredCheckedCheckboxes[index];
      }

      var displayText = _this.displayTextGenerator();

      _this.setState(function (prevState) {
        return {
          selectedItemIndex: index,
          selectedItemText: displayText,
          selectedItemValue: _this.selectedValueArray.join(', '),
          focusedItemIndex: index,
          searchedText: _objectSpread(_objectSpread({}, prevState.searchedText), {}, {
            show: false
          })
        };
      }, onChange(_this.globalCheckedCheckboxes));
    });

    _defineProperty(_assertThisInitialized(_this), "returnFocus", function () {
      _this.dropdown.querySelector('input').focus();
    });

    _defineProperty(_assertThisInitialized(_this), "searchClick", function (e) {
      var disabled = _this.props.disabled;
      e.stopPropagation();

      if (disabled) {
        return;
      }

      _this.setState(function (prevState) {
        return {
          searchedText: _objectSpread(_objectSpread({}, prevState.searchedText), {}, {
            show: true
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchFocus", function () {
      _this.setState(function (prevState) {
        return {
          open: true,
          searchedText: _objectSpread(_objectSpread({}, prevState.searchedText), {}, {
            show: true
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchBlur", function () {
      _this.setState(function (prevState) {
        return {
          searchedText: _objectSpread(_objectSpread({}, prevState.searchedText), {}, {
            show: false
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "dropdownPanelFocus", function () {
      _this.setState(function (prevState) {
        return {
          searchedText: _objectSpread(_objectSpread({}, prevState.searchedText), {}, {
            show: true
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "dropdownPanelBlur", function () {
      _this.setState(function (prevState) {
        return {
          searchedText: _objectSpread(_objectSpread({}, prevState.searchedText), {}, {
            show: false
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeDropdownPanelOnKeyDown", function () {
      _this.close();

      _this.dropdownPanelBlur();
    });

    _defineProperty(_assertThisInitialized(_this), "displayTextGenerator", function () {
      var _this$props2 = _this.props,
          defaultText = _this$props2.defaultText,
          showFullSelected = _this$props2.showFullSelected,
          selectedDisplayTextBefore = _this$props2.selectedDisplayTextBefore,
          selectedDisplayTextAfter = _this$props2.selectedDisplayTextAfter;
      var displayText;

      if (showFullSelected) {
        displayText = _this.selectedArray.join(', ');
      } else if (Object.values(_this.globalCheckedCheckboxes).length === 0) {
        displayText = defaultText;
      } else if (Object.values(_this.globalCheckedCheckboxes).length === 1) {
        /* eslint-disable-next-line prefer-destructuring */
        displayText = Object.values(_this.globalCheckedCheckboxes)[0];
      } else {
        displayText = "".concat(selectedDisplayTextBefore, " ").concat(Object.values(_this.globalCheckedCheckboxes).length, " ").concat(selectedDisplayTextAfter);
      }

      return displayText;
    });

    _defineProperty(_assertThisInitialized(_this), "handleTab", function (event) {
      if (event.which === TAB_KEY) {
        _this.closeDropdownPanelOnKeyDown();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleShiftTab", function (event) {
      if (event.which === TAB_KEY && event.shiftKey) {
        _this.closeDropdownPanelOnKeyDown();

        _this.returnFocus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "generatePlaceHolderText", function () {
      var _this$props3 = _this.props,
          defaultText = _this$props3.defaultText,
          searchable = _this$props3.searchable;
      var _this$state3 = _this.state,
          open = _this$state3.open,
          selectedItemText = _this$state3.selectedItemText;

      if (searchable) {
        if (open) {
          return 'Search...';
        } else {
          return defaultText;
        }
      } else if (selectedItemText === '' || selectedItemText === null) {
        return defaultText;
      } else {
        return selectedItemText;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "generateValueText", function () {
      var searchable = _this.props.searchable;
      var _this$state4 = _this.state,
          open = _this$state4.open,
          searchedText = _this$state4.searchedText,
          selectedItemText = _this$state4.selectedItemText;

      if (searchable) {
        if (open) {
          return searchedText.value;
        } else if (Object.values(_this.globalCheckedCheckboxes).length !== 0) {
          return selectedItemText;
        } else {
          return '';
        }
      } else if (open && (selectedItemText === '' || selectedItemText === null)) {
        return '';
      } else if (open && Object.values(_this.globalCheckedCheckboxes).length !== 0) {
        return selectedItemText;
      } else if (open) {
        return '';
      } else if (Object.values(_this.globalCheckedCheckboxes).length === 0) {
        return '';
      } else {
        return selectedItemText;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "resetSelection", function () {
      var onChange = _this.props.onChange;
      _this.selectedArray = [];
      _this.globalCheckedCheckboxes = {};

      _this.setState({
        selectedItemText: '',
        searchedText: {
          value: '',
          show: false
        },
        selectedItemValue: '',
        selectedItemIndex: null
      }, onChange(_this.globalCheckedCheckboxes));
    });

    _defineProperty(_assertThisInitialized(_this), "applySelection", function () {
      var onChange = _this.props.onChange;
      onChange(_this.globalCheckedCheckboxes);

      _this.close();
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectAllToggle", function (event) {
      var _this$props4 = _this.props,
          options = _this$props4.options,
          onChange = _this$props4.onChange;

      if (event.target.checked) {
        var allOptionalValueArray = [];
        _this.selectedArray = allOptionalValueArray.concat(options);
        Object.assign(_this.globalCheckedCheckboxes, _this.filteredCheckboxes);
      } else {
        _this.selectedArray = [];
        Object.keys(_this.filteredCheckboxes).forEach(function (key) {
          if (_this.globalCheckedCheckboxes[key] !== undefined) {
            delete _this.globalCheckedCheckboxes[key];
          }
        });
        _this.filteredCheckedCheckboxes = {};
      }

      var displayText = _this.displayTextGenerator();

      _this.setState({
        selectedItemText: displayText
      }, onChange(_this.globalCheckedCheckboxes));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCheckboxes", function (generatedCheckboxes) {
      if (_this.filteredCheckboxes && Object.values(_this.filteredCheckboxes).length > 0) {
        return generatedCheckboxes;
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: "margintop-lg marginleft-md"
        }, "No results found");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "checkboxGenerator", function (isChecked, value, defaultText, checkboxId, index, disabled, info) {
      return /*#__PURE__*/React.createElement(Checkbox, {
        role: "option",
        "aria-selected": isChecked,
        className: "listitem__checkbox",
        value: value,
        name: defaultText,
        id: checkboxId,
        key: checkboxId,
        index: index,
        disabled: disabled,
        checked: isChecked,
        tabIndex: 0,
        onChange: function onChange(e) {
          return _this.handleSelects(info, e);
        },
        onKeyDown: _this.handleOptionTab
      });
    });

    var _this$props5 = _this.props,
        _defaultText = _this$props5.defaultText,
        _open = _this$props5.open,
        _selected = _this$props5.selected,
        selectedIndex = _this$props5.selectedIndex;
    _this.focusableItems = [];
    _this.selectedArray = _selected || [];
    _this.filteredCheckboxes = {};
    _this.filteredCheckedCheckboxes = {};
    _this.globalCheckedCheckboxes = _this.setCheckedValues();
    _this.selectedValueArray = [];
    _this.state = {
      open: _open,
      selectedItemIndex: selectedIndex,
      selectedItemText: _selected || _defaultText,
      selectedItemValue: _this.selectedValueArray.join(', '),
      focusedItemIndex: -1,
      searchedText: {
        value: '',
        show: false
      }
    };
    return _this;
  }

  _createClass(DropdownMultiselect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.focusableItems = this.dropdown.querySelectorAll('[type="checkbox"], [role="option"]');
      this.setDisplayText();
      this.globalCheckedCheckboxes = this.setCheckedValues();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var selected = this.props.selected;
      /* focusableItems list can change on updates when component is searchable */

      this.focusableItems = this.dropdown.querySelectorAll('[type="checkbox"], [role="option"]');

      if (selected !== prevProps.selected) {
        this.selectedArray = selected;
        this.globalCheckedCheckboxes = this.setCheckedValues();
        this.setDisplayText();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props6 = this.props,
          alignRight = _this$props6.alignRight,
          applyText = _this$props6.applyText,
          changeLabelOnSelect = _this$props6.changeLabelOnSelect,
          className = _this$props6.className,
          defaultText = _this$props6.defaultText,
          description = _this$props6.description,
          disabled = _this$props6.disabled,
          dropUp = _this$props6.dropUp,
          dynamicDropAlign = _this$props6.dynamicDropAlign,
          dynamicDropDirection = _this$props6.dynamicDropDirection,
          error = _this$props6.error,
          id = _this$props6.id,
          iconNameClose = _this$props6.iconNameClose,
          iconNameOpen = _this$props6.iconNameOpen,
          label = _this$props6.label,
          labelWidth = _this$props6.labelWidth,
          loader = _this$props6.loader,
          onChange = _this$props6.onChange,
          options = _this$props6.options,
          panelHeight = _this$props6.panelHeight,
          panelWidth = _this$props6.panelWidth,
          placeholder = _this$props6.placeholder,
          required = _this$props6.required,
          resetText = _this$props6.resetText,
          searchable = _this$props6.searchable,
          selectAllLabel = _this$props6.selectAllLabel,
          selected = _this$props6.selected,
          selectedDisplayTextAfter = _this$props6.selectedDisplayTextAfter,
          selectedDisplayTextBefore = _this$props6.selectedDisplayTextBefore,
          selectedIndex = _this$props6.selectedIndex,
          showFullSelected = _this$props6.showFullSelected,
          size = _this$props6.size,
          removeMarginTop = _this$props6.removeMarginTop,
          hideFooterButtons = _this$props6.hideFooterButtons,
          hideSelectAll = _this$props6.hideSelectAll,
          other = _objectWithoutProperties(_this$props6, _excluded);

      var _this$state5 = this.state,
          open = _this$state5.open,
          searchedText = _this$state5.searchedText,
          selectedItemIndex = _this$state5.selectedItemIndex,
          selectedItemText = _this$state5.selectedItemText;
      var selectAllCheckboxClasses = classNames({
        'border-bottom': true,
        'marginbottom-md': true
      });
      var fieldID = id || this.props.fieldID;

      var generatedSelectAll = function generatedSelectAll() {
        if (hideSelectAll || !options || options.length === 0) {
          return null;
        }

        var checkedDeterminer = 1;
        var globalLength = Object.values(_this2.globalCheckedCheckboxes).length;
        var filteredLength = Object.values(_this2.filteredCheckboxes).length;
        var filteredCheckedLength = Object.values(_this2.filteredCheckedCheckboxes).length;

        if (searchedText.value && searchedText.value.length > 0) {
          if (filteredCheckedLength === 0) {
            checkedDeterminer = 0;
          } else if (filteredLength > filteredCheckedLength) {
            checkedDeterminer = 2;
          }
        } else if (globalLength === 0) {
          checkedDeterminer = 0;
        } else if (options.length > globalLength) {
          checkedDeterminer = 2;
        }

        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
          label: selectAllLabel,
          value: checkedDeterminer,
          tabIndex: 0,
          checked: checkedDeterminer,
          name: "".concat(fieldID, "-SelectAll"),
          onChange: function onChange(e) {
            return _this2.handleSelectAllToggle(e);
          }
        }), /*#__PURE__*/React.createElement("div", {
          style: {
            marginLeft: '-16px',
            marginRight: '-16px'
          },
          className: selectAllCheckboxClasses
        }));
      };
      /* eslint-disable-next-line array-callback-return, consistent-return */


      var generatedCheckboxes = options.map(function (value, index) {
        var isChecked = false;
        var checkboxId = "".concat(fieldID, "_checkbox_").concat(index);
        var info = {
          value: value,
          index: index
        };

        if (_this2.globalCheckedCheckboxes && _this2.globalCheckedCheckboxes[info.index] !== undefined) {
          isChecked = true;
        }

        if (searchable && searchedText.value && searchedText.value.length > 0) {
          if (value.toLowerCase().includes(searchedText.value.toLowerCase())) {
            Object.assign(_this2.filteredCheckboxes, _defineProperty({}, index, value));

            if (isChecked) {
              Object.assign(_this2.filteredCheckedCheckboxes, _defineProperty({}, index, value));
            }

            return _this2.checkboxGenerator(isChecked, value, defaultText, checkboxId, index, disabled, info);
          }
        } else {
          Object.assign(_this2.filteredCheckboxes, _defineProperty({}, index, value));
          return _this2.checkboxGenerator(isChecked, value, defaultText, checkboxId, index, disabled, info);
        }
      });
      var currentIcon;

      if (!dropUp) {
        if (open) {
          currentIcon = iconNameClose;
        } else {
          currentIcon = iconNameOpen;
        }
      } else if (open) {
        currentIcon = iconNameOpen;
      } else {
        currentIcon = iconNameClose;
      }

      var dropdownClasses = classNames(_defineProperty({
        dropdown: true,
        'maxwidth-100p': true
      }, className, className));
      var comboboxProps = {
        'aria-owns': "".concat(fieldID, "_listbox"),
        'aria-controls': "".concat(fieldID, "_listbox"),
        'aria-autocomplete': 'list',
        role: 'combobox',
        'aria-label': label,
        'aria-activedescendant': selectedItemIndex !== null ? "".concat(fieldID, "-listitem-").concat(selectedItemIndex) : null,
        onChangeValue: function onChangeValue(e) {
          return _this2.onSearchType(e);
        }
      };
      return /*#__PURE__*/React.createElement(ArrowKeyListener, {
        onUp: this.onUpArrow,
        onDown: this.onDownArrow
      }, /*#__PURE__*/React.createElement(ClickListener, {
        onClickOutside: this.close
      }, /*#__PURE__*/React.createElement("div", {
        className: dropdownClasses,
        ref: function ref(_ref) {
          _this2.dropdown = _ref;
        },
        style: {
          width: labelWidth
        }
      }, /*#__PURE__*/React.createElement(DropdownField, _extends({
        name: "".concat(fieldID, "-DropdownField"),
        label: label,
        error: error,
        description: description,
        required: required,
        onClick: this.toggleDropdown,
        onChange: this.onSearchType,
        onKeyDown: function onKeyDown(e) {
          _this2.searchArrowKeyPress(e);

          _this2.handleShiftTab(e);

          _this2.handleTab(e);

          _this2.handleKeyDown(e);
        } // onKeyPress={this.toggleDropdown}
        ,
        size: size,
        placeholder: this.generatePlaceHolderText(),
        onFocus: this.searchFocus,
        onBlur: this.searchBlur,
        value: this.generateValueText(),
        disabled: disabled,
        "aria-haspopup": "listbox",
        isExpanded: open,
        searchable: searchable,
        iconName: currentIcon,
        removeMarginTop: removeMarginTop
      }, searchable && comboboxProps)), /*#__PURE__*/React.createElement("div", {
        className: classNames({
          'position-relative': true,
          'width-100p': true
        }),
        style: {
          marginTop: description || error ? '-20px' : 0
        }
      }, /*#__PURE__*/React.createElement(DropdownPanel, {
        isOpen: open,
        width: panelWidth,
        height: searchedText.value ? 'auto' : panelHeight,
        alignRight: alignRight,
        dropUp: dropUp,
        dynamicDropAlign: dynamicDropAlign,
        dynamicDropDirection: dynamicDropDirection,
        fieldSize: size
      }, loader ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement("div", null, !searchedText.value && generatedSelectAll(), /*#__PURE__*/React.createElement("ul", {
        role: "listbox",
        "aria-multiselectable": "true",
        id: "".concat(fieldID, "_listbox"),
        onFocus: this.dropdownPanelFocus,
        onBlur: this.dropdownPanelBlur,
        style: {
          marginLeft: '-8px'
        },
        "aria-labelledby": "".concat(fieldID, "-DropdownField")
      }, this.renderCheckboxes(generatedCheckboxes)), !hideFooterButtons && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "paddingbottom-lg"
      }), /*#__PURE__*/React.createElement(Button, {
        kind: "secondary",
        size: "small",
        onClick: this.resetSelection,
        className: "marginright-md"
      }, resetText), /*#__PURE__*/React.createElement(Button, {
        className: "applyButtonMultiselect",
        kind: "primary",
        size: "small",
        onClick: this.applySelection,
        onKeyDown: this.handleTab
      }, applyText))))))));
    }
  }]);

  return DropdownMultiselect;
}(Component);

_defineProperty(DropdownMultiselect, "propTypes", {
  id: PropTypes.string,

  /** ID for dropdown input field - will be deprecated. Please use 'id' */
  fieldID: PropTypes.string,

  /** Add label for Dropdown select field */
  label: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,

  /** Default text of the dropdown */
  defaultText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Value of the dropdown */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  onChange: PropTypes.func,

  /** Default selected item from the DropdownItem to display on the dropdown button */
  selectedItem: PropTypes.string,
  open: PropTypes.bool,

  /** icon name for opening the dropdown */
  iconNameOpen: PropTypes.string,

  /** icon name for closing the dropdown */
  iconNameClose: PropTypes.string,
  disabled: PropTypes.bool,

  /** Add description for Dropdown select field */
  description: PropTypes.string,

  /** Add error description for Dropdown select field */
  error: PropTypes.string,

  /** Set true if field is required */
  required: PropTypes.bool,

  /** size of the button/input field element */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /** Deprecating prop. Default is true for dropdownKind 'select' and false for 'menu' */
  changeLabelOnSelect: PropTypes.bool,

  /** custom dropdown label width. Default is 100% */
  labelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** custom dropdown panel width. Default is 100% on dropdownKind 'select'. Enter width number for dropdownKind 'menu' (suggested width: 240px) */
  panelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** set dropdown panel height to allow vertical scrolling. Default is auto. */
  panelHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** indicates if you want to have the dropdown panel to align right */
  alignRight: PropTypes.bool,

  /** indicates if you want to have the dropdown panel to open up */
  dropUp: PropTypes.bool,

  /** indicates if the dropdown should should open in the opposite direction (up or down) when it would otherwise go over the edge of the page */
  dynamicDropDirection: PropTypes.bool,

  /** indicates if the dropdown should align with the opposite side of its value field when it would otherwise go over the edge of the page */
  dynamicDropAlign: PropTypes.bool,
  selectedIndex: PropTypes.number,

  /** indicates whether the dropdown should be a combo box with search type-ahead  */
  searchable: PropTypes.bool,

  /** Display all selected items separated by comma on the dropdown field */
  showFullSelected: PropTypes.bool,

  /** Text displayed before the number of selected items */
  selectedDisplayTextBefore: PropTypes.string,

  /** Text displayed after the number of selected items */
  selectedDisplayTextAfter: PropTypes.string,

  /** The options to be used as inputs */
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),

  /** The selected value */
  selected: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),

  /** Placeholder of the dropdown field */
  placeholder: PropTypes.string,

  /** Reset button text */
  resetText: PropTypes.string,

  /** Apply button text */
  applyText: PropTypes.string,

  /** Label for select all option */
  selectAllLabel: PropTypes.string,

  /** show loader when loading */
  loader: PropTypes.bool,

  /** Remove margin top above the input label */
  removeMarginTop: PropTypes.bool,

  /** Hide footer buttons (Apply and Reset) when set to true */
  hideFooterButtons: PropTypes.bool,

  /** Set true to hide select all option at the top of the list */
  hideSelectAll: PropTypes.bool
});

_defineProperty(DropdownMultiselect, "defaultProps", {
  open: false,
  disabled: false,
  iconNameOpen: 'arrow_drop_down',
  iconNameClose: 'arrow_drop_up',
  onChange: function onChange() {},
  changeLabelOnSelect: true,
  alignRight: false,
  error: '',
  required: false,
  dropUp: false,
  dynamicDropDirection: false,
  dynamicDropAlign: false,
  selectedIndex: null,
  labelWidth: '100%',
  panelWidth: '100%',
  panelHeight: 'auto',
  searchable: true,
  showFullSelected: true,
  selectedDisplayTextAfter: '',
  selectedDisplayTextBefore: '',
  resetText: 'Reset',
  applyText: 'Apply',
  fieldID: 'dropdownMultiselect',
  label: '',
  hideFooterButtons: false,
  hideSelectAll: false
});

DropdownMultiselect.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onUpArrow",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onDownArrow",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onSearchType",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "setCheckedValues",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "setDisplayText",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "searchArrowKeyPress",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "iterateDropdownFocus",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "focusIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "close",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleKeyDown",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "open",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "toggleDropdown",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleSelects",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "info",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "returnFocus",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "searchClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "searchFocus",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "searchBlur",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "dropdownPanelFocus",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "dropdownPanelBlur",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "closeDropdownPanelOnKeyDown",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "displayTextGenerator",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleTab",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleShiftTab",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "generatePlaceHolderText",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "generateValueText",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "resetSelection",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "applySelection",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleSelectAllToggle",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderCheckboxes",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "generatedCheckboxes",
      "type": null
    }],
    "returns": null
  }, {
    "name": "checkboxGenerator",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "isChecked",
      "type": null
    }, {
      "name": "value",
      "type": null
    }, {
      "name": "defaultText",
      "type": null
    }, {
      "name": "checkboxId",
      "type": null
    }, {
      "name": "index",
      "type": null
    }, {
      "name": "disabled",
      "type": null
    }, {
      "name": "info",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "DropdownMultiselect",
  "props": {
    "open": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "iconNameOpen": {
      "defaultValue": {
        "value": "'arrow_drop_down'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "icon name for opening the dropdown"
    },
    "iconNameClose": {
      "defaultValue": {
        "value": "'arrow_drop_up'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "icon name for closing the dropdown"
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "changeLabelOnSelect": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Deprecating prop. Default is true for dropdownKind 'select' and false for 'menu'"
    },
    "alignRight": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates if you want to have the dropdown panel to align right"
    },
    "error": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Add error description for Dropdown select field"
    },
    "required": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set true if field is required"
    },
    "dropUp": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates if you want to have the dropdown panel to open up"
    },
    "dynamicDropDirection": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates if the dropdown should should open in the opposite direction (up or down) when it would otherwise go over the edge of the page"
    },
    "dynamicDropAlign": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates if the dropdown should align with the opposite side of its value field when it would otherwise go over the edge of the page"
    },
    "selectedIndex": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "labelWidth": {
      "defaultValue": {
        "value": "'100%'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "custom dropdown label width. Default is 100%"
    },
    "panelWidth": {
      "defaultValue": {
        "value": "'100%'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "custom dropdown panel width. Default is 100% on dropdownKind 'select'. Enter width number for dropdownKind 'menu' (suggested width: 240px)"
    },
    "panelHeight": {
      "defaultValue": {
        "value": "'auto'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "set dropdown panel height to allow vertical scrolling. Default is auto."
    },
    "searchable": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates whether the dropdown should be a combo box with search type-ahead"
    },
    "showFullSelected": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display all selected items separated by comma on the dropdown field"
    },
    "selectedDisplayTextAfter": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Text displayed after the number of selected items"
    },
    "selectedDisplayTextBefore": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Text displayed before the number of selected items"
    },
    "resetText": {
      "defaultValue": {
        "value": "'Reset'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Reset button text"
    },
    "applyText": {
      "defaultValue": {
        "value": "'Apply'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Apply button text"
    },
    "fieldID": {
      "defaultValue": {
        "value": "'dropdownMultiselect'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "ID for dropdown input field - will be deprecated. Please use 'id'"
    },
    "label": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Add label for Dropdown select field"
    },
    "hideFooterButtons": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Hide footer buttons (Apply and Reset) when set to true"
    },
    "hideSelectAll": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set true to hide select all option at the top of the list"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "defaultText": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Default text of the dropdown"
    },
    "value": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Value of the dropdown"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "selectedItem": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Default selected item from the DropdownItem to display on the dropdown button"
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Add description for Dropdown select field"
    },
    "size": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": "size of the button/input field element"
    },
    "options": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "number"
          }]
        }
      },
      "required": false,
      "description": "The options to be used as inputs"
    },
    "selected": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "number"
          }]
        }
      },
      "required": false,
      "description": "The selected value"
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder of the dropdown field"
    },
    "selectAllLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Label for select all option"
    },
    "loader": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "show loader when loading"
    },
    "removeMarginTop": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Remove margin top above the input label"
    }
  }
};
export default DropdownMultiselect;